interface ISvgDirectoryProps {
    height: number | string;
    width: number | string;
    color: string;
}

const SvgDirectory: React.FC<ISvgDirectoryProps> = (props) => {
    return (
        <svg width={props.width} height={props.height} viewBox="0 0 60 61" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M42.5 38H47.5V43H42.5V38ZM42.5 28H47.5V33H42.5V28ZM42.5 18H47.5V23H42.5V18ZM34.35 18L37.5 20.1V18H34.35Z" fill={props.color} />
            <path d="M25 8V11.775L30 15.1V13H52.5V48H42.5V53H57.5V8H25Z" fill={props.color} />
            <path d="M20.425 14.75L37.5 26.125V53H2.5V26.7L20.425 14.75ZM25 48H32.5V28.4L20.425 20.725L7.5 28.95V48H15V33H25V48Z" fill={props.color} />
        </svg>
    );
};

export default SvgDirectory;
